import Fuse from 'fuse.js';
import { useMasterMedicines } from './useMasterMedicines';
import { MasterMedicine } from '../../apis/master-medicines/types';

export const useSearchMasterMedicines = (searchTerm: string) => {
  const { masterMedicines, isLoaded, refetch, total } = useMasterMedicines();

  const similarMasterMedicines = searchMasterMedicineByName(masterMedicines, searchTerm);

  return {
    masterMedicines: similarMasterMedicines,
    isLoaded,
    total,
    refetch
  };
};

const searchMasterMedicineByName = (masterMedicines: MasterMedicine[], searchTerm: string) => {
  const fuse = new Fuse(masterMedicines, {
    keys: ['name'],
    threshold: 0.5
  });

  const searchResult = fuse.search(searchTerm);

  return searchResult.map(result => result.item);
};
